

@if (isLoading) {
  <div class="_deals-page-centered">
    <img [src]="loadingLogo" *ngIf="loadingLogo" draggable="false" />
    <div>loading...</div>
  </div>
} @else if (!deal2) {
  <div class="_deals-page-centered">
    @if (tenant?.Branding?.LogoImageUrl) {
      <img [src]="tenant.Branding.LogoImageUrl" draggable="false" />
    }
    <div>somethings gone wrong...</div>
  </div>
} @else {
  <div class="_deals-page" [class.isModal]="isModal">
    <div class="_deals-page-header">
      <h1>{{ deal2.name }}</h1>

      <a class="_close-button" (click)="cancelDeal()">
        <span class="material-symbols-outlined"> close </span>
      </a>
    </div>

    <div class="_deals-page-content">
      <div class="flex-row no-wrap" style="padding-right: 10px; width: 100%">
        @if (deal2.description || deal2.price) {
          <div class="flex-column no-wrap" style="flex: 1">
            <p class="_deals-page-description" [appTruncate]="4">{{ deal2.description }}</p>
            <p class="_deals-page-price-summary">{{ deal2.price }}</p>
          </div>
        }

        @if (!tenant.SuppressProductImages && deal2.imageBase) {
          <div class="_deals-image-wrapper"
              [class.image-only]="!deal2.description && !deal2.price"
              role="button"
              tabindex="0"
              (click)="openImageLightbox(deal2.imageBase)"
              (keydown.enter)="openImageLightbox(deal2.imageBase)"
              (keydown.space)="openImageLightbox(deal2.imageBase)">
            <img [src]="deal2.imageBase" class="_deals-image" [alt]="deal2.name" [draggable]="false" />
            <div class="_zoom-overlay">
              <mat-icon>zoom_in</mat-icon>
            </div>
          </div>
        }
      </div>

      @if (!deal2.available) {
        <span class="_deals-page-content-unavailable">
          Sorry - This deal is currently unavailable
        </span>
      }

      <ul class="_deals-page-content-lines-wrapper">
        @for (line2 of deal2.lines; track line2) {
          <li class="_deals-page-content-line-item" [class._deal-line-selected]="line2.selectedItem">
            @if (line2.selectedItem) {
              <div class="selected-product-line flex-row no-wrap">
                @if (!tenant.SuppressProductImages && line2.selectedItem.imageBase) {
                  <img [src]="line2.selectedItem.imageBase" draggable="false" [alt]="line2.selectedItem.name" loading="lazy"/>
                }

                <div class="flex-column no-wrap">
                  <span>{{ line2.selectedItem.name }}</span>
                  <a (click)="toggleLineItem(line2)">Change</a>
                </div>
              </div>
            } @else {
              <div class="un-selected-product-line flex-row flex-align-center no-wrap" (click)="toggleLineItem(line2)">
                <span class="material-symbols-outlined"> add_circle </span>
                @if (line2.webSections) {
                  <span>Choose your {{ line2.webSections }}</span>
                } @else {
                  <span>Choose {{ $index + 1 }}</span>
                }
              </div>
            }
          </li>
        }
      </ul>
    </div>

    <div class="_deals-page-footer disable-select">
      <button class="_deals-page-footer-button button-action-mat button-action-1"
              [class.button-action-disabled]="!isDealComplete()"
              [disabled]="!isDealComplete()"
              tabindex="-1"
              mat-button
              (click)="addDealToCart()">
        <div style="display: flex">
          <div style="display: flex; align-items: center; flex: 1">
            <span class="material-symbols-outlined"> local_mall </span>
            <span>Add to Basket</span>
          </div>
        </div>
      </button>
    </div>
  </div>
}

<ng-template #CustomiseProductModal>
  <app-product [productView]="productView" [occasion]="occasion" (onClose)="closeProductModal()"></app-product>
</ng-template>

<ng-template #ChooseDealLineModal>
  <section class="_deal-line-modal">
    <div class="_deals-page-header">
      <h1>Choose your {{ selectedLine.webSections ?? 'product' }}</h1>

      <a class="_close-button" (click)="closeModalById('chooseDealLineModal')">
        <span class="material-symbols-outlined"> close </span>
      </a>
    </div>

    <ul>
      @for (lineItem of selectedLine.items; track lineItem) {
        <li class="_deal-line flex-row no-wrap flex-align-center"
            [class.selected]="lineItem.product.Id === selectedLine.selectedItem?.productId"
            [class._deal-item-unavailable]="!lineItem.available"
            (click)="addProductToDeal(lineItem, selectedLine)">
          @if (!tenant.SuppressProductImages && lineItem.imageBase) {
            <img [src]="lineItem.imageBase" draggable="false" [alt]="lineItem.product.Name" loading="lazy"/>
          }

          <div class="_deal-line-details">
            <h2>{{ lineItem.product.Name }}</h2>
            <span>{{ lineItem.product.Description }}</span>

            @if (lineItem.nutritionSummary) {
              <span>{{ lineItem.nutritionSummary }}</span>
            }
          </div>
        </li>
      }
    </ul>
  </section>
</ng-template>

